import {Component} from '@angular/core';
import {IHeaderGroupAngularComp} from 'ag-grid-angular';
import {IHeaderGroupParams} from 'ag-grid-community';
import {Store} from '../../../../store';

@Component({
    selector: 'app-shock-mtm-value',
    templateUrl: './shock-mtm-value.component.html',
    styleUrls: ['./shock-mtm-value.component.scss'],
    standalone: false
})
export class ShockMtmValueComponent implements IHeaderGroupAngularComp {
    public selectedValue: string | undefined = '';

    constructor(private store: Store) { }

    agInit(params: IHeaderGroupParams): void {
        this.selectedValue = this.store.value.shockMtmValue;
    }

    selectedValueChange(newValue: string) {
        this.selectedValue = newValue;
        this.store.set('shockMtmValue', this.selectedValue);
    }
}